import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { ILanguageInfo } from '@models';

import {
    combineLatest,
    Observable,
} from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ui-language-selector',
    templateUrl: './ui-language-selector.component.html',
    styleUrls: ['./ui-language-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLanguageSelectorComponent implements OnInit {
    @Input()
    public languages$!: Observable<ILanguageInfo[]>;

    @Output()
    public change = new EventEmitter<ILanguageInfo['Name']>();

    public currentLanguage$!: Observable<ILanguageInfo>;

    constructor(
        private _appState: AppStateFacade,
    ) { }

    ngOnInit() {
        this.currentLanguage$ =
            combineLatest([
                this.languages$,
                this._appState.language.value$,
            ]).pipe(
                map(([languages, currentLanguageIdentifier]) =>
                    languages.find(
                        lang => lang.Name === currentLanguageIdentifier,
                    )!,
                ),
            );
    }

    public changeLanguage(language: ILanguageInfo) {
        this.change.emit(language.Name);
    }
}
